var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-action-container",class:{'dashboard': _vm.inDashboard}},[_c('div',{staticClass:"start-container"},[_vm._t("default")],2),_c('div',{staticClass:"end-container"},[_vm._t("end")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }